(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-base"] && !Shopify.designMode) return;
  try {
    
(function () {
  var C = window.DEVORE || {};
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* countdown — todas as instâncias [data-countdown] */
  var cds = document.querySelectorAll('[data-countdown]');
  if (cds.length) {
    var target = new Date(C.launch).getTime();
    var tick = function () {
      var diff = Math.max(0, target - Date.now());
      var d = Math.floor(diff / 86400000), h = Math.floor(diff / 3600000) % 24,
          m = Math.floor(diff / 60000) % 60, s = Math.floor(diff / 1000) % 60;
      cds.forEach(function (c) {
        c.querySelector('[data-cd="days"]').textContent = pad(d);
        c.querySelector('[data-cd="hours"]').textContent = pad(h);
        c.querySelector('[data-cd="minutes"]').textContent = pad(m);
        c.querySelector('[data-cd="seconds"]').textContent = pad(s);
      });
    };
    tick(); setInterval(tick, 1000);
  }

  /* reveal on scroll (rAF — funciona em webviews/in-app) */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.lp-reveal'));
  var inView = function (el, m) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight - m && r.bottom > 0; };
  var ticking = false;
  var checkReveal = function () {
    ticking = false;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      if (inView(revealEls[i], 60)) { revealEls[i].classList.add('is-visible'); revealEls.splice(i, 1); }
    }
  };
  var onScrollR = function () { if (!ticking) { ticking = true; requestAnimationFrame(checkReveal); } };
  window.addEventListener('scroll', onScrollR, { passive: true });
  window.addEventListener('resize', onScrollR, { passive: true });
  checkReveal();
  setTimeout(function () { revealEls.forEach(function (el) { el.classList.add('is-visible'); }); }, 4000);

  /* sticky CTA (mobile): aparece quando o botão do hero sai; some no rodapé */
  var sticky = document.querySelector('.lp-sticky-cta');
  var heroBtn = document.querySelector('[data-hero-cta]');
  var footer = document.querySelector('[data-lp-footer]');
  if (sticky && heroBtn) {
    var checkSticky = function () {
      var out = heroBtn.getBoundingClientRect().bottom <= 0;
      var footVis = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      sticky.classList.toggle('is-shown', out && !footVis);
    };
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  /* modal */
  var modal = document.querySelector('[data-modal]');
  if (modal) {
    var stepForm = modal.querySelector('[data-step="form"]');
    var stepSuccess = modal.querySelector('[data-step="success"]');
    var open = function () { modal.hidden = false; document.body.style.overflow = 'hidden'; stepForm.hidden = false; stepSuccess.hidden = true; var n = modal.querySelector('input[name="nome"]'); if (n) n.focus(); };
    var close = function () { modal.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('.js-open-modal').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-modal-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    var form = modal.querySelector('form.lp-form');
    if (form) {
      var err = form.querySelector('[data-form-error]');
      var nomeEl = form.querySelector('[name="nome"]');
      var emailEl = form.querySelector('[name="email"]');
      var phone = form.querySelector('[name="whatsapp"]');
      phone.addEventListener('input', function () {
        var v = phone.value.replace(/\D/g, '').slice(0, 11);
        if (v.length > 7) v = '(' + v.slice(0,2) + ') ' + v.slice(2,7) + '-' + v.slice(7);
        else if (v.length > 2) v = '(' + v.slice(0,2) + ') ' + v.slice(2);
        phone.value = v;
      });
      var fail = function (msg, el) { err.textContent = msg; err.hidden = false; if (el) { el.classList.add('is-invalid'); el.focus(); } };
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        err.hidden = true;
        form.querySelectorAll('.is-invalid').forEach(function (i) { i.classList.remove('is-invalid'); });
        var nome = nomeEl.value.trim(), email = emailEl.value.trim(), wa = phone.value.replace(/\D/g, '');
        if (nome.length < 2) return fail('Conta pra gente seu nome :)', nomeEl);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return fail('Esse e-mail não parece válido.', emailEl);
        if (wa.length < 10) return fail('Digite seu WhatsApp com DDD.', phone);

        /* 1) Planilha (Google Apps Script) — fire-and-forget, sem CORS */
        if (C.sheet) {
          try {
            var payload = JSON.stringify({ nome: nome, email: email, whatsapp: wa, origem: 'lp-lancamento', data: new Date().toISOString() });
            fetch(C.sheet, { method: 'POST', mode: 'no-cors', body: payload }).catch(function () {});
          } catch (e2) {}
        }
        /* 2) Sucesso + redirect (não depende da planilha — nunca trava o usuário) */
        stepForm.hidden = true; stepSuccess.hidden = false;
        var link = stepSuccess.querySelector('[data-whatsapp-link]'); link.href = C.whatsapp;
        var countEl = stepSuccess.querySelector('[data-redirect-count]');
        var rem = C.delay || 3; countEl.textContent = rem;
        var t = setInterval(function () { rem--; countEl.textContent = Math.max(0, rem); if (rem <= 0) { clearInterval(t); window.location.href = C.whatsapp; } }, 1000);
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
